import { TrendingDown, AlertTriangle } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { formatINR, formatDate } from '@/lib/format';

export const MissedOpportunity = ({ items = [] }) => {
  const totalMissed = items.reduce((s, i) => s + (i.value || 0), 0);
  return (
    <Card className="p-5" data-testid="missed-opportunity-card">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="flex items-center gap-2">
            <div className="h-7 w-7 rounded-full bg-rose-500/10 grid place-items-center">
              <TrendingDown className="h-3.5 w-3.5 text-rose-500" />
            </div>
            <h3 className="font-display text-base font-semibold">Reward leakage</h3>
          </div>
          <p className="mt-1 text-xs text-muted-foreground">Where you missed rewards this month</p>
        </div>
        <Badge variant="outline" className="font-mono-num text-rose-500 border-rose-500/30 bg-rose-500/5">
          {formatINR(totalMissed, { compact: true })}
        </Badge>
      </div>

      <ul className="mt-4 space-y-3">
        {items.map((it) => (
          <li key={it.id} className="flex items-start gap-3 rounded-lg border border-border bg-[hsl(var(--surface-2))] p-3">
            <div className="mt-0.5 h-7 w-7 rounded-full grid place-items-center bg-amber-500/10 text-amber-500 shrink-0">
              <AlertTriangle className="h-3.5 w-3.5" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm text-foreground leading-snug">{it.text}</p>
              <div className="mt-1 flex items-center gap-2 text-[11px] text-muted-foreground">
                <span>{formatDate(it.date)}</span>
                <span>·</span>
                <span className="font-mono-num text-rose-500">{formatINR(it.value)} missed</span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
};
